interface SectionHeaderProps {
  label?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

export function SectionHeader({ label, title, description, align = 'left' }: SectionHeaderProps) {
  const alignClass = align === 'center' ? 'text-center mx-auto' : '';

  return (
    <div className={`max-w-2xl ${alignClass} mb-10 md:mb-14`}>
      {label && (
        <span className="brand-text block mb-3">{label}</span>
      )}
      <h2 className="heading-section text-foreground">{title}</h2>
      {description && (
        <p className="text-body mt-4 max-w-xl">{description}</p>
      )}
    </div>
  );
}
